// extracted by mini-css-extract-plugin
module.exports = {"Text":"Info_Text__1kW4g"};